import { withAuthGate } from '@sunrise-ui/composites';
import { useAuthStore } from '@sunrise-ui/primitives';
import ProfileView from '@templates/ProfileView';
import React from 'react';

function ProfileScreen() {
  const { currentUserId } = useAuthStore();

  return <ProfileView userId={currentUserId} />;
}

export default withAuthGate(ProfileScreen);
